import { render } from "./TwitterBox.vue?vue&type=template&id=d67a4f36&scoped=true"
import script from "./TwitterBox.vue?vue&type=script&lang=js"
export * from "./TwitterBox.vue?vue&type=script&lang=js"

import "./TwitterBox.vue?vue&type=style&index=0&id=d67a4f36&scoped=true&lang=css"

import exportComponent from "E:\\backup\\Programowanie\\kurs\\vue\\cam-scrapper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d67a4f36"]])

export default __exports__